import { Modal } from "@/components/ui/modal";
import { Pencil, ChevronRight, Library } from "lucide-react";
import { useI18n } from '@/hooks/useI18n';
import { ActivityType } from "../models/activity.model";
import { getActivityTypeIcon } from "../models/activity-configs.model";

interface ActivitySourceChoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  activityType: ActivityType;
  onChooseManual: () => void;
  onChooseLibrary: () => void;
}

/**
 * Scelta rapida "crea manualmente / scegli dalla libreria", mostrata prima di
 * creare una nuova attività (non accommodation, che ha già il proprio
 * AccommodationChoiceModal con anche l'opzione RateHawk).
 */
export function ActivitySourceChoiceModal({
  isOpen,
  onClose,
  activityType,
  onChooseManual,
  onChooseLibrary,
}: ActivitySourceChoiceModalProps) {
  const { t } = useI18n();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div className="flex items-center gap-2">
          {getActivityTypeIcon(activityType)} {t('library.sourceChoiceTitle')}
        </div>
      }
      size="sm"
    >
      <div className="p-4 flex flex-col gap-3">
        <button
          onClick={onChooseManual}
          className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 text-left w-full transition-colors hover:bg-gray-50"
        >
          <Pencil className="h-5 w-5 text-gray-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{t('library.createManuallyAction')}</p>
            <p className="text-sm text-gray-500 mt-0.5">{t('library.createManuallyDescription')}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
        </button>

        <button
          onClick={onChooseLibrary}
          className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors text-left w-full"
        >
          <Library className="h-5 w-5 text-gray-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{t('library.chooseFromLibraryAction')}</p>
            <p className="text-sm text-gray-500 mt-0.5">{t('library.chooseFromLibraryDescription')}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
        </button>
      </div>
    </Modal>
  );
}
